import { combineReducers } from "@reduxjs/toolkit";

import globalLoadingReducer from './global-loading-slice';
import menuClickReducer from './menu-click-slice';
import loginUserReducer from './auth-slice';
import activityLogsReducer from './activity-logs-slice';
import roleManagementInboxReducer from './role-management-inbox-slice';
import userManagementInboxReducer from './user-management-inbox-slice';
import rolesListReducer from './roles-list-slice';
import institutionsListReducer from './institutions-list-slice';
import permissionsListReducer from './permissions-list-slice';
import schemesListReducer from './schemes-list-slice';
import usersReducer from './users-slice';
import rolesReducer from './roles-slice';
import participantsReducer from './participants-slice';
import participantManagementInboxReducer from './participant-management-inbox-slice';
import acsParametersReducer from './acs-parameters-slice';
import acsParametersInboxReducer from './acs-parameters-inbox-slice';
import authenticationHistoryReducer from './authentication-history-slice';
import cardStatusManagementReducer from './card-status-management-slice';
import cardStatusFileImportLogsReducer from './card-status-file-import-logs-slice';
import authenticationHistoryExportReducer from './authentication-history-export-slice';
import auditLogsReducer from './audit-logs-slice';
import ruleEngineReducer from './rule-engine-slice';
import ruleEngineManagementInboxReducer from './rule-engine-management-inbox-slice';
import mccBlockReducer from './mcc-block-slice';
import MCCBlockManagementInboxReducer from './mcc-management-inbox-slice';
import apiConfigReducer from './api-config-slice';
import ApiConfigManagementInboxReducer from './api-config-management-inbox-slice';
import globalCountryCodeBlockReducer from './global-country-code-block-slice';
import CountryCodeBlockManagementInboxSlice from './country-code-management-inbox-slice';
import ReportCatalogReducer from './report-catalog-slice';

const appReducer = combineReducers({
  globalLoadingReducer,
  menuClickReducer,
  loginUserReducer,
  activityLogsReducer,
  roleManagementInboxReducer,
  userManagementInboxReducer,
  rolesListReducer,
  institutionsListReducer,
  permissionsListReducer,
  schemesListReducer,
  usersReducer,
  rolesReducer,
  participantsReducer,
  participantManagementInboxReducer,
  acsParametersReducer,
  acsParametersInboxReducer,
  authenticationHistoryReducer,
  authenticationHistoryExportReducer,
  auditLogsReducer,
  ruleEngineReducer,
  ruleEngineManagementInboxReducer,
  mccBlockReducer,
  apiConfigReducer,
  ApiConfigManagementInboxReducer,
  MCCBlockManagementInboxReducer,
  globalCountryCodeBlockReducer,
  CountryCodeBlockManagementInboxSlice,
  cardStatusManagementReducer,
  cardStatusFileImportLogsReducer,
  ReportCatalogReducer,
});

const RootReducer = (state, action) => {
  // when logout is fulfilled, reset all state
  if (action.type === "user/logout/fulfilled") {
    state = undefined; // resets all reducers to their initialState
  }
  return appReducer(state, action);
};

export default RootReducer;